<div class="system-attribute-container" *ngIf="!containsError">
  <div>
    <div>
    <span class="pageHeader" id="devUpdateAttributesHeader">

								Update System Attributes
								</span>

    </div>
    <br><br><br>

    <div *ngIf="successMess">
      <div class="successMessAlign">
        <p>
        <li>System Attribute has been successfully updated.</li>
        </p>
      </div>
    </div>
    <div class="error-container" *ngIf="showErrorDiv">
      <p>{{errHeading}}</p>
      <p>
      <li> {{errMessage}}</li>
      OR
      <li>{{errMessage2}}</li>
      </p>
    </div>
    <div class="indicates">
      <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
	            required information</span>
    </div><br>
    <span class="adminTblAlign">
        <div class="ui-g-3 lblAlign"><label class="EMBRequiredControl"> + &nbsp; </label>  System Attribute:  </div>
        <div class="ui-g-3">   <fm-select
          [options]="sysAttr"
          [(ngModel)]="selectedAttr"
        ></fm-select></div>
      </span><br>
    <div class="btnAlign">
      <button fmButton type="button" [small]="true" [primary]="true" label="Search" class="dispbuttonMargin"
              (click)="getSystemAttr()"></button>
      <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>
  </div>
  <br>
  <div class="resultTbl" *ngIf="loader">
    <table class="lblAlign">
      <tr>
        <td>System Attribute Name:</td>
        <td class="resultLblAlign">{{attrName}}</td>
      </tr>
      <tr>
        <td><span class="EMBRequiredControl">+</span>System Attribute Value:</td>
        <td class="resultLblAlign">
          <input type="text" fmTextInput [(ngModel)]="attrVal" (keyup)="trackKeyPress($event)" class="resizedTextbox"></td>
      </tr>
      <tr>
        <td> Flag Name:</td>
        <td class="resultLblAlign">{{flagName}}</td>
      </tr>
      <tr>
        <td> Flag Value:</td>
        <td class="resultLblAlign">
          <fm-select
            [options]="flagVal"
            [(ngModel)]="selectedFlag"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
    </table>
    <div>
      <button fmButton type="button" [small]="true" label="Update" class="update-button-admin-attr"
              [primary]="true" (click)="updateSystemAttributesLimit()"></button>
    </div>
  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
